var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#13A0F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66707 6.50698C4.44689 6.39149 4.26251 6.21796 4.13391 6.00518C4.00531 5.79239 3.93739 5.54848 3.9375 5.29985C3.84136 5.11756 3.78794 4.91578 3.78128 4.7098C3.77462 4.50381 3.8149 4.29901 3.89906 4.11089C3.98323 3.92276 4.10908 3.75625 4.26709 3.62393C4.4251 3.49162 4.61114 3.39698 4.81112 3.34717C5.01111 3.29736 5.2198 3.29369 5.42141 3.33643C5.62302 3.37917 5.81228 3.46721 5.97485 3.59388C6.13742 3.72055 6.26905 3.88253 6.35978 4.06758C6.45051 4.25263 6.49797 4.45588 6.49857 4.66198C7.26663 4.21282 8.14062 3.9767 9.03038 3.97798C11.8091 3.97798 14.0625 6.23585 14.0625 9.02023C14.0625 11.8046 11.8097 14.0625 9.03038 14.0625C6.25107 14.0625 3.99825 11.8052 3.99825 9.02023C3.99696 8.13832 4.22761 7.27159 4.66707 6.50698ZM9.03038 11.5009C10.3973 11.5009 11.5054 10.3905 11.5054 9.02023C11.5054 7.64998 10.3973 6.5396 9.03038 6.5396C7.6635 6.5396 6.55538 7.65054 6.55538 9.02023C6.55538 10.3899 7.6635 11.5009 9.03038 11.5009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBela);
export default __webpack_public_path__ + "static/media/bela.a9e0eafde5b5f15cab0ca8149ef10ef4.svg";
export { ForwardRef as ReactComponent };